import React from "react";
import "./Plus.css";

function Plus() {
  return (
    <div className="plus">
      <div className="vector-container">
        <img className="vector-28" src="/img/vector-15@2x.png" />
        <img className="vector-28" src="/img/vector-16@2x.png" />
      </div>
    </div>
  );
}

export default Plus;
